// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vNUUuTkGKR2ywemXQl_a{height:34px;text-align:center;font-size:18px;font-weight:bold;margin:0 10px}`, "",{"version":3,"sources":["webpack://./../../../tools/nodeEditor/dist/graphSystem/display/remapDisplayManager.modules.scss"],"names":[],"mappings":"AAAA,sBACI,WAAA,CACA,iBAAA,CACA,cAAA,CACA,gBAAA,CACA,aAAA","sourcesContent":[".remap-block {\r\n    height: 34px;\r\n    text-align: center;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"remap-block": `vNUUuTkGKR2ywemXQl_a`
};
export default ___CSS_LOADER_EXPORT___;
